import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home'
import Course from './views/Course'
import Person from './views/Person'
import Resource from './views/Resource'
import Post from './views/Post'
import CourseDetail from './views/CourseDetail.vue'
import TopicDetail from './views/TopicDetail.vue'
import Topic from './views/Topic.vue'
import Insight from './views/Insight.vue'
import Usability from './views/Usability.vue'
import Base from './views/Base.vue'
import UserCenter from './views/UserCenter'
const WritePost = () => import("./views/WritePost.vue")
import UpCourse from "./views/UpCourse.vue"
import {baseUrl} from '@/assets/js/const'
import {GetQueryString} from '@/assets/js/common'
import Axios from '@/assets/js/ajax'
Vue.use(Router)
let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/index',
    },
    {
      path: '/index',
      name: 'home',
      component: Home
    },    
    {
      path: '/course',
      name: 'course',
      component: Course
    },
    {
      path: '/resource',
      name: 'resource',
      component: Resource
    },
    {
      path: '/insight',
      name: 'insight',
      component: Insight
    },
    {
      path: '/usability',
      name: 'usability',
      component: Usability
    },
    {
      path: '/person',
      name: 'person',
      component: Person
    },
    {
      path: '/p/:id',
      name: 'p',
      component: Post
    },
    {
      path: '/coursedetail/:id',
      name: 'coursedetail',
      component: CourseDetail
    },
    {
      path: '/topic',
      name: 'topic',
      component: Topic
    },
    {
      path: '/topicdetail/:id',
      name: 'topicdetail',
      component: TopicDetail
    },
    {
      path: '/base',
      name: 'base',
      component: Base
    },
    {
      path: '/usercenter/:id',
      name: 'usercenter',
      component: UserCenter
    },
    {
      path: '/writepost/:id',
      name: 'writepost',
      component: WritePost
    },
    {
      path: '/upcourse/:id',
      name: 'upcourse',
      component: UpCourse
    },
    {
      path: '/search',
      name: 'search',
      component: () => import('./views/Search')
    }
  ]
})
router.beforeEach((to, from, next) => {
  var code = GetQueryString('code')
  if (code) {
  Axios.get(baseUrl + '/code/' + code, {})
    .then(response => {
      if (response.data.errcode === 0) {
          if(sessionStorage.getItem('currentUrl').indexOf('ueclub.kingdee')!==-1) {
            location.href = sessionStorage.getItem('currentUrl')
          }
        
      }
    })
    .catch(error => {
      console.log(error)
    })
  } else {
    next()
  }
})
export default router